<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="grid">
        <div class="col-12">
          <div class="formgrid grid">
            <div class="field col-12 md:col-4">
              <label>No. Pajak</label>
              <InputText
                v-model="form.pajak_no"
                :class="{ 'p-invalid': v$.form.pajak_no.$invalid && submitted }"
                type="text"
                class="w-full"
                input-class="w-full"
              />
              <small
                v-if="
                  (v$.form.pajak_no.$invalid && submitted) ||
                  v$.form.pajak_no.$pending.$response
                "
                class="p-error"
                >{{ v$.form.pajak_no.required.$message }}</small
              >
            </div>
            <div class="field col-12 md:col-4">
              <label>Expire</label>
              <Calendar
                v-model="form.expired_at"
                dateFormat="dd/mm/yy"
                date-format="dd/mm/yy"
                class="w-full"
                :class="{
                  'p-invalid': v$.form.expired_at.$invalid && submitted,
                }"
              />
              <small
                v-if="
                  (v$.form.expired_at.$invalid && submitted) ||
                  v$.form.expired_at.$pending.$response
                "
                class="p-error"
                >{{ v$.form.expired_at.required.$message }}</small
              >
            </div>
            <div class="field col-12 md:col-4">
              <label>Status</label>
              <Dropdown
                v-model="form.status"
                :options="list_status"
                :disabled="
                  form.id === 0 ||
                  (form.status !== 'open' && form.status !== 'rejected')
                "
                class="w-full"
                input-class="w-full"
                optionValue="id"
                optionLabel="nama"
              />
              <small
                v-if="
                  (v$.form.status.$invalid && submitted) ||
                  v$.form.status.$pending.$response
                "
                class="p-error"
                >{{ v$.form.status.required.$message }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  computed: {
    form() {
      return this.item
    },
    list_status() {
      return [
        { id: 'open', nama: 'Open' },
        { id: 'assigned', nama: 'Assigned' },
        { id: 'rejected', nama: 'Rejected' },
      ]
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true
      if (!isFormValid) {
        return
      }
      this.$emit('edit', this.form)
    },
  },
  validations() {
    return {
      form: {
        pajak_no: {
          required: helpers.withMessage('Nilai harus diisi.', required),
        },
        expired_at: {
          required: helpers.withMessage('Nilai harus diisi.', required),
        },
        status: {
          required: helpers.withMessage('Nilai harus diisi.', required),
        },
      },
    }
  },
}
</script>

<style>
.p-combobox-label {
  position: relative;
  width: calc(100% - 24px);
}

.p-combobox-label-container {
  width: 100%;
  position: relative;
}

.p-combobox-icon-remove {
  position: absolute;
  top: 2px;
  right: 0;
  color: red;
}
</style>
